import type { Snapshot } from '@ember-data/legacy-compat/-private';
import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import type Store from '@ember-data/store';
import type { ModelSchema } from '@ember-data/store/types';
import type { BeniUpsell } from 'lumen/models';
import ApplicationSerializer from 'lumen/serializers/application';

interface UpsellResponse {
  'beni-upsell': BeniUpsell[];
}

// eslint-disable-next-line @typescript-eslint/no-unsafe-call
export default class BeniUpsellSerializer extends ApplicationSerializer.extend(
  EmbeddedRecordsMixin,
) {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  normalizeResponse(
    store: Store,
    primaryModelClass: ModelSchema,
    payload: UpsellResponse,
    id: string | number,
    requestType: string,
  ) {
    // The backend only returns the response for the GET request in this format.
    // So we only normalize the response for queryRecord.
    // For the POST request, we can use the default normalizeResponse method.
    if (requestType === 'queryRecord') {
      const normalizedPayload = {
        'benchmark-insight/upsell': payload['beni-upsell'],
      };

      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
      return super.normalizeResponse(
        store,
        primaryModelClass,
        normalizedPayload,
        id,
        requestType,
      );
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return super.normalizeResponse(
      store,
      primaryModelClass,
      payload,
      id,
      requestType,
    );
  }

  serializeIntoHash(
    hash: BeniUpsell,
    _ModelClass: unknown,
    snapshot: Snapshot,
  ): void {
    /*
        By default, the payload for saving a record would be:
        {
            beniUpsell: {
                light_requested: true,
                trial_requested: true
            }
        }

        Instead, we want the payload to be:
        {
            light_requested: true,
            trial_requested: true
        }
    */
    // @ts-expect-error: 'snapshot.record' is of type 'unknown'.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
    const { lightRequested } = snapshot.record.getProperties('lightRequested');
    // @ts-expect-error: 'snapshot.record' is of type 'unknown'.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
    const { trialRequested } = snapshot.record.getProperties('trialRequested');
    Object.assign(hash, {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      light_requested: lightRequested,
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      trial_requested: trialRequested,
    });
  }
}
